/**
 * TASK EDIT MODAL — Dialog centrale per l'inline edit di un Task.
 *
 * Aperto dal click su una row della TaskList / dashboard. Chrome e layout
 * allineati alla modale di creazione (header chiaro + kicker "Modifica task",
 * corpo TaskEditModalBody con titolo eroe + pill + Più opzioni). Ogni campo
 * salva inline, quindi NON c'è un submit — la X e "Chiudi" chiudono soltanto.
 *
 * Ha sostituito il vecchio pannello laterale (SidePanel): la modifica ora si
 * apre al centro come la creazione, non più come drawer da destra. Il vecchio
 * TaskEditFormBody (layout compatto a griglia) resta per l'embed nella timeline.
 */

import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import { TaskEditModalBody } from './TaskEditModalBody';
import type { Task } from './taskTypes';

interface TaskEditModalProps {
  task: Task;
  onClose: () => void;
}

export function TaskEditModal({ task, onClose }: TaskEditModalProps) {
  const { t } = useTranslation();
  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth className="app-dialog">
      <DialogTitle className="tc-head">
        <span className="tc-kicker">{t('task.editTask')}</span>
        <IconButton
          aria-label={t('common.close')}
          onClick={onClose}
          size="small"
          className="tc-x"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent className="app-dialog__body">
        <TaskEditModalBody task={task} />
      </DialogContent>
      <DialogActions className="app-dialog__footer">
        {/* Nessun submit: i campi salvano inline. "Chiudi" è solo un exit chiaro. */}
        <Button variant="contained" onClick={onClose}>{t('common.close')}</Button>
      </DialogActions>
    </Dialog>
  );
}
